var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3133_1676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4804 63.8719L75.9988 34.3543L105.532 63.8871L122.708 46.7111L75.9988 0L29.3051 46.6959L46.4804 63.8719ZM0 75.9976L17.1765 58.8211L34.3519 75.9966L17.1755 93.173L0 75.9976ZM46.4804 88.1281L75.9988 117.646L105.532 88.1136L122.717 105.281L122.708 105.29L75.9988 152L29.3036 105.306L29.2793 105.281L46.4804 88.1281ZM117.649 76.0071L134.825 58.8306L152 76.006L134.824 93.1825L117.649 76.0071Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4214 75.9916H93.429L75.9999 58.5625L63.1195 71.443H63.1187L61.639 72.9235L58.5868 75.9764L58.5625 75.9999L58.5868 76.025L75.9999 93.4389L93.429 76.0098L93.4374 75.9999L93.4214 75.9916Z",
    fill: "#F3BA2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3133_1676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.f5989e2d60f197f66e40a4d55fe54b60.svg";
export { ForwardRef as ReactComponent };